import { ReactNode, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";



type ToolLayoutProps = { title: string; description: string; children: ReactNode; local?: boolean; };

/**
 * Displays a developer tool's heading, metadata and local-processing notice.
 * @param props Component properties.
 * @param props.title Page heading and SEO title.
 * @param props.description Page introduction and meta description.
 * @param props.children Tool controls or landing-page cards.
 * @param props.local Whether to show the local-processing notice.
 */
export const ToolLayout = (props: ToolLayoutProps) => {
	useEffect(() => {
		const previousTitle = document.title;
		const meta = document.querySelector('meta[name="description"]');
		const previousDescription = meta?.getAttribute("content");
		document.title = `${ props.title } | NumaSuite Developer Tools`;
		meta?.setAttribute("content", props.description);
		return () => {
			document.title = previousTitle;
			if(previousDescription !== null && previousDescription !== undefined) meta?.setAttribute("content", previousDescription);
		};
	}, [ props.title, props.description ]);

	return (
		<Box component="main" sx={{ maxWidth: "1100px", width: "100%", boxSizing: "border-box", mx: "auto", px: { xs: 2, sm: 4 }, py: 5,
			"& .MuiTypography-root": { fontFamily: "Raleway, Arial, sans-serif" }, "& h1.MuiTypography-root, & h2.MuiTypography-root, & button, & a": { fontFamily: "Red Rose, Arial, sans-serif" }, "& .MuiButton-root": { textTransform: "none" },
			"& .MuiButton-contained": { backgroundColor: "#1e1559" }, "& a:focus-visible, & button:focus-visible": { outline: "3px solid #3B0E59", outlineOffset: "3px" }
		}}>
			{ props.local && <Button component={ Link } to="/developer/tools" sx={{ mb: 2 }}>All developer tools</Button> }
			<Typography component="h1" sx={{ fontSize: { xs: "28px", sm: "36px" }, fontWeight: 600, color: "#3B0E59", mb: 2 }}>{ props.title }</Typography>
			<Typography sx={{ fontFamily: "Raleway", mb: 3 }}>{ props.description }</Typography>
			{ props.local && <Typography sx={{ fontFamily: "Raleway", mb: 3, fontSize: "14px" }}>Processed locally — your input never leaves your browser.</Typography> }
			{ props.children }
		</Box>
	);
};
